import React from 'react';
import styled, { css } from 'styled-components';

import ActionButton from './ActionButton';
import { ADD_SUB_ACTION_LABEL } from 'src/presentation/components/pages/sidekick/threads/SidekickConstants';
import AddStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/add-stroke';
import DropdownMenu from '@ad-scripts/presentation/components/common/dropdown_menu_v2';
import { StyledAddModuleContainer } from 'src/presentation/components/pages/sidekick/threads/components/AddModule';
import useAddModifier from 'src/presentation/components/pages/sidekick/threads/hooks/useAddModifier';

const AddModifierButton = ({ moduleId, disabled, moduleSpec }) => {
  const { hasModifiers, options, handleAddModifier } = useAddModifier({
    moduleId,
    moduleSpec,
    readOnly: disabled,
  });

  if (!hasModifiers) {
    return null;
  }

  return (
    <StyedDropdownMenu
      options={options}
      fitOpenerWidth={false}
      onSelect={handleAddModifier}
      renderCustomOpener={({ setTargetRef, onToggle, isOpen }) => {
        const handleToggle = e => {
          e.stopPropagation();
          onToggle(e);
        };
        return (
          <StyledAddModuleContainer disabled={disabled} ref={setTargetRef} onClick={handleToggle}>
            <StyledActionButton
              isOpen={isOpen}
              onClick={e => {
                e.preventDefault();
              }}
              title={ADD_SUB_ACTION_LABEL}
            >
              <AddStrokeIcon width="16" alt={ADD_SUB_ACTION_LABEL} />
            </StyledActionButton>
          </StyledAddModuleContainer>
        );
      }}
    />
  );
};

const StyedDropdownMenu = styled(DropdownMenu)`
  min-width: 200px;
`;

const cssVisible = css`
  background-color: rgba(0, 0, 0, 0.04);
  visibility: visible;
`;

const StyledActionButton = styled(ActionButton)`
  ${p => p.isOpen && cssVisible}
`;

export default AddModifierButton;
